import apiClient from './api';
import { Layer } from '@/types/api';

class LayerService {
  /**
   * GET /api/userLayers — returns all layers (paginated, default 20 per page)
   * Backend returns LayersDTO[] with: id, layerName, displayName, menu, subMenu, geoserver, layerWorkspace, orderInMenu
   */
  async getAllUserLayers(): Promise<Layer[]> {
    try {
      // Request a large page size to get all layers in one call
      const response = await apiClient.get<Layer[]>('/userLayers', {
        params: { size: 200 },
      });
      return response.data;
    } catch (error) {
      console.error('Failed to load layers:', error);
      throw error;
    }
  }

  /**
   * GET /api/userLayersForMenu?subMenuId={menuId} — layers for a given menu
   * Despite the param name, the backend uses this as a menu ID
   */
  async getLayersForMenu(menuId: number): Promise<Layer[]> {
    try {
      const response = await apiClient.get<Layer[]>('/userLayersForMenu', {
        params: { subMenuId: menuId },
      });
      return response.data;
    } catch (error) {
      console.error(`Failed to load layers for menu ${menuId}:`, error);
      throw error;
    }
  }

  /**
   * GET /api/userLayers/{id} — single layer details
   */
  async getLayerDetails(layerId: number): Promise<Layer> {
    const response = await apiClient.get<Layer>(`/userLayers/${layerId}`);
    return response.data;
  }
}

export const layerService = new LayerService();
export default layerService;
